<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">保険費レート詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_IR_NEW>{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="$router.go(-1)">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                label="運送形態"
                url="transport-modes/kv"
                v-model="form.transportModeId"
              />
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                item-text="code"
                label="適用建値"
                url="incoterms/kv"
                v-model="form.incotermId"
              />
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <v-text-field
                :rules="[
          v=>  v && /^(([1-9][0-9]*)|(([0]\.\d{1,10}|[1-9][0-9]*\.\d{1,10})))$/.test(v)  || `rate cannot exceed 10 decimal places`]"
                clearable
                label="保険レート"
                v-model="form.rate"
              />
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <date-picker label="適用開始日" v-model="form.startDate"/>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <date-picker :min="form.startDate" label="適用終了日" v-model="form.endDate"/>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                :all="{ text: '全体', value: -1 }"
                :rules="[v => !!v || `海外取引先 is required`]"
                label="海外取引先"
                url="companies/kv?type=PARTNER"
                v-model="form.supplierId"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {}
    }
  },
  methods: {
    save() {
      this.$http
        .post('/insurance-rates', {
          ...this.form,
          supplierId: this.form.supplierId === -1 ? null : this.form.supplierId
        })
        .then(() => {
          this.$router.go(-1)
        })
    }
  }
}
</script>
